import React from "react";
import Card from "@material-ui/core/Card";
import Tooltip from "@material-ui/core/Tooltip";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import Skeleton from "@material-ui/lab/Skeleton";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress";

export function SkeletonState(props) {
  const { image, loading } = props;
  return (
    <Card
      style={{
        padding: "10px",
        margin: "5px",
        maxWidth: "470px",
        display: "inline-block",
        position: "relative"
      }}
    >
      <CardContent style={{ textAlign: "center", lineHeight: 0, padding: 0 }}>
        {image ? (
          <img
            style={{ width: "100%", maxWidth: "400px" }}
            alt={`State`}
            src={`data:image/png;base64,${image}`}
          />
        ) : (
          <React.Fragment>
            {loading ? (
              <CircularProgress />
            ) : (
              <Skeleton variant="rect" width={367} height={91.75} />
            )}
          </React.Fragment>
        )}
      </CardContent>
    </Card>
  );
}

function State(props) {
  const { state, deleteFunc } = props;

  return (
    <Tooltip title={`State ${state.trajectoryId}-${state.timestep}`}>
      <Card
        style={{
          padding: "10px",
          margin: "5px",
          maxWidth: "470px",
          display: "inline-block",
          position: "relative"
        }}
      >
        {deleteFunc && (
          <IconButton
            aria-label="delete"
            onClick={deleteFunc}
            style={{ position: "absolute", top: "-5px", right: "-5px" }}
          >
            <DeleteIcon />
          </IconButton>
        )}
        {state.binaryImage ? (
          <CardContent
            style={{ textAlign: "center", lineHeight: 0, padding: 0 }}
          >
            <img
              style={{ width: "100%", maxWidth: "400px" }}
              alt={`State ${state.timestep}`}
              src={`data:image/png;base64,${state.binaryImage}`}
            />
          </CardContent>
        ) : (
          <Skeleton variant="rect" width={400} height={100} />
        )}
      </Card>
    </Tooltip>
  );
}

export default State;



// WEBPACK FOOTER //
// ./src/sections/data/components/State.js